import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import { buildQueryParams } from '@/hooks/api/helpers';
import type { FanguardApiContractsClientEventDetailModel } from 'src/api/generated';
import { PagedResponse } from 'src/types/GlobalTypes';

export const EVENTS_URI = 'events';

export const eventsQueries = createQueryKeys(EVENTS_URI, {
  all: null,
  list: (
    venueId?: string,
    page?: number,
    pageSize?: number,
    viewMode?: 'calendar' | 'list',
    startDate?: string,
    endDate?: string,
    includePastEvents?: boolean,
  ) => {
    const normalized =
      viewMode === 'calendar'
        ? {
            venueId,
            page: undefined,
            pageSize: undefined,
            viewMode: undefined,
            startDate: undefined,
            endDate: undefined,
            includePastEvents: undefined,
          }
        : { venueId, page, pageSize, viewMode, startDate, endDate, includePastEvents };

    return {
      queryKey: [
        normalized.venueId,
        normalized.page,
        normalized.pageSize,
        normalized.viewMode,
        normalized.startDate,
        normalized.endDate,
        normalized.includePastEvents,
      ],
      queryFn: async () => {
        const response = await get<PagedResponse<FanguardApiContractsClientEventDetailModel>>({
          uri: `${EVENTS_URI}?${buildQueryParams(normalized)}`,
        });
        return response.data;
      },
    };
  },
  detail: (eventId: string) => ({
    queryKey: [eventId],
    queryFn: async () => {
      const response = await get<FanguardApiContractsClientEventDetailModel>({
        uri: `${EVENTS_URI}/${eventId}`,
      });
      return response.data;
    },
  }),
});
